export enum MODELS {
  /**
   * GPT 3.5 Turbo
   */
  GPT3_5 = 'gpt-3.5-turbo',
  GPT3_5_1106 = 'gpt-3.5-turbo-1106',
  GPT3_5_16K = 'gpt-3.5-turbo-16k',
  /**
   * GPT 4
   */
  GPT4o = 'gpt-4o',
  GPT4 = 'gpt-4',
  GPT4_32K = 'gpt-4-32k',
  GPT4_PREVIEW = 'gpt-4-1106-preview',
  GPT4_VISION_PREVIEW = 'gpt-4-vision-preview',
  CODEGENIUS = 'ft:gpt-4o-2024-08-06:personal:faithgpt:A5oDEppd',
  DALLE3 = 'dall-e-3',

  /**
   * Fine-tuned models
   */
  // FAITHGPT = 'ft:gpt-3.5-turbo-1106:personal::8qRi1hq0',
  FAITHGPT = 'ft:gpt-4o-2024-08-06:personal:faithgpt:A5oDEppd',
  FAITHGPTMINI = 'ft:gpt-4o-mini-2024-07-18:personal:faithgpt-mini:A5oDbcny',
  AZURE_FAITHGPT = 'gpt-4o-2024-08-06.ft-de529d4dc3a24bbcbc56afeba50928da-faithgpt-large',
  AZURE_FAITHGPT_MINI = 'gpt-4o-mini-2024-07-18.ft-ead3ca84c9f841518a2a9376895a15e9-faithgpt-mini',
}
